<template>
  <div>
    <bar-manut single-entity="ivancm" plural-entity="NCM`s x CST-IBS/CBS" :crud="this.crud" :btn-delete="true"
      @closeform="closeForm" @delete="handleDelete" @save="handleSave">
    </bar-manut>
    <validation v-if="errmessages.length != 0" :messages="errmessages"></validation>
    <div class="default-container">
      <div>
        <div class="row">
          <form-field v-model="ivancm.codivancm" :metadata="metadata.ivancm.codivancm" type="text" col="2"
            :disabled="true" name="codivancm" :v-errors="errors" v-validate="metadata.ivancm.codivancm.validator">
          </form-field>
          <div class="w-100"></div>
          <form-field ref="ncm" v-model="ivancm.ncm" type="select2" col="6" :metadata="metadata.ivancm.ncm"
            :select2="{ entity: 'ncm', minlength: 1 }"></form-field>
          <div class="w-100"></div>
          <form-field v-model="ivancm.cclass" type="select2" col="4" :metadata="metadata.ivancm.cclass" name="cclass"
            :v-errors="errors" v-validate="metadata.ivancm.cclass.validator" parent="mymodal"
            :select2="{ entity: 'ivaclass', minlength: 0 }"></form-field>

        </div>
      </div>
    </div>
  </div>

</template>

<script>

import { SysVars } from '../main'
import { apiORDSpost, apiORDSdelete } from '../shared/api-functions'

export default {
  props: {
    index: '',
    crud: '',
  },

  data() {
    return {
      crudText: '',
      ivancm: { ...this.$store.getters.getEntities.ivancm },
      metadata: this.$store.getters.getEntities.metadata,
      errmessages: [],  //armazena as mensagens de validacao do servidor para mostrar em tela
    }
  },

  computed: {
    editing: function () {
      return this.crud == SysVars.crudU
    }

  },

  methods: {
    closeForm() {
      this.$emit('closeform')
    },

    handleSave() {
      //BOTAO SALVAR
      this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
        } else {
          this.apiPost()
        }
      })
    },

    handleDelete() {
      //BOTAO Excluir
      this.apiDelete()
    },

    async loadData() {
      //carrega o registro para alteracao ou visualizacao
      await this.$store.dispatch('loadivancm', { id: this.index })
      if (this.$store.getters.getivancm) {
        this.ivancm = { ...this.$store.getters.getivancm }
      }
      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip()
      })
    },

    async apiDelete() {
      //efetua a exclusao
      var modulo = 'cg/ivancm/' + this.ivancm.codivancm

      const data = await apiORDSdelete(this.$store, modulo)
      this.$erpToastDeleted()
      this.closeForm()
    },

    async apiPost() {
      //efetua a gravacao

      var modulo = 'cg/ivancm/'
      var sendData = {}

      sendData = { ivancm: this.ivancm }

      let metodo = 'post'
      let update = false
      if (this.crud != SysVars.crudI) {
        metodo = 'put'
        update = true
      }

      const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
      if (data.errmessages) {
        this.errmessages = data.errmessages
        this.$erpToastError('Alguns erros precisam ser corrigidos.')
      } else {
        if (update) {
          this.$erpToastUpdated()
        } else {
          this.$erpToastInserted()
        }
        this.errmessages = {}
        this.closeForm()
      }
    },

  },

  components: {

  },

  beforeCreate() {

  },

  created() {
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip()
    })

    this.crudText = this.$crudText(this.crud)

    if (this.crud == SysVars.crudI) {
    } else {
      this.loadData()
    }
  }

}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/ivancm-form.vue